import * as _ from 'lodash';

export const shouldRequest = (_data, _invalidAfter, _lastUpdated) => {
  // Case 1: Data is marked as always outdated (never cached)
  const shouldNeverCacheData = _invalidAfter === 0;
  if (shouldNeverCacheData) {
    return true;
  }

  // Case 2: In case the data is missing, always request it
  const isDataMissing = _.isEmpty(_data);
  if (isDataMissing) {
    return true;
  }

  // Case 3: Check if the cached data is still valid
  const now = new Date().valueOf();
  const isLimitExceeded = now - _lastUpdated >= _invalidAfter;
  if (isLimitExceeded) {
    return true;
  }

  // Case 4: The data is valid!
  return false;
};

/**
 * Class that holds all common action creators and the related logic
 */
class ActionCreators {
  constructor(reducerName, actions, requestDataCall) {
    this.reducerName = reducerName;
    this.actions = actions;
    this.requestDataCall = requestDataCall;
  }

  /**
   * The common (internal) action creators
   */
  request = () => ({ type: this.actions.REQUEST });
  receive = data => ({ type: this.actions.RECEIVE, data });
  fail = error => ({ type: this.actions.FAIL, error });

  requestDataIfNeeded = params => (dispatch, getState) => {
    const store = getState()[this.reducerName];
    const { data, invalidAfter, lastUpdated } = store;

    const shouldRequestData = shouldRequest(data, invalidAfter, lastUpdated);

    if (!shouldRequestData) {
      return Promise.resolve();
    }

    return this.requestData(dispatch, getState, params);
  };

  requestData = (dispatch, getState, params) => {
    return new Promise((resolve, reject) => {
      dispatch(this.request());
      const state = getState()[this.reducerName];

      this.requestDataCall(state, params, dispatch)
        .then((data) => {
          dispatch(this.receive(data));
          resolve(data);
        })
        .catch(err => {
          dispatch(this.fail(err));
          reject(err);
        });
    });
  };

  // TODO: Invalidate data.
  // invalidate = () => ({ type: this.actions.INVALIDATE })
  // doInvalidate = () => dispatch =>  dispatch(this.invalidate());
}

/**
 * Makes the common ActionCreators
 *
 * @param  {String} reducerName - the name of the reducer (store) item
 * @param  {Object} actions - Holds a mapping of the entity specific actions,
 *                            @example: {
 *                               REQUEST: 'app/home/REQUEST_EXHIBITIONS',
 *                               RECEIVE: 'app/home/RECEIVE_EXHIBITIONS_SUCCESS',
 *                               FAIL: 'app/home/RECEIVE_EXHIBITIONS_FAIL',
 *                             }
 * @param  {Promise} requestDataCall - The actual data request.
 * @return {ActionCreators}
 */
export const makeActionCreators = ({ reducerName, actions, requestDataCall }) =>
  new ActionCreators(reducerName, actions, requestDataCall);



// WEBPACK FOOTER //
// ./src/core/make-action-creators.js